import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { TeamTransactionsData } from '../../../models/RevShareData';
import ExportButtons from '../components/ExportButtons';
import PeriodLabel from '../components/PeriodLabel';
import TransactionsTableHeader from '../components/TransactionsTableHeader';
import { PricebookTable, pricebookHeaders } from './PricebookTable';
import { TransactionsTableProps } from '../Transactions';
import TransactionsSkeleton from '../components/TransactionsSkeleton';
import {
  AmountPaidSubtotal,
  AmountPaidTotal,
  RevShareSubtotal,
  RevShareTotal,
} from '../components/TransactionsTotalsLabels';

interface TeamTransactionsTableProps extends TransactionsTableProps {
  data: TeamTransactionsData | undefined;
}

const TeamTransactionsTable: React.FC<TeamTransactionsTableProps> = ({
  data,
  startDate,
  endDate,
  onExportPdf,
  emptyStateText,
  loading,
}) => {
  return (
    <Box>
      <TransactionsTableHeader
        headers={pricebookHeaders}
        totals={{
          amountPaid: <AmountPaidTotal total={data?.subscriptionTotalAmount ?? 0} />,
          revShareAmount: <RevShareTotal total={data?.revShareTotalAmount ?? 0} />,
        }}
        leftContent={
          startDate &&
          endDate && (
            <Box>
              <PeriodLabel start={startDate} end={endDate} color='info.main' variant='p16' />
              <Box pt={2}>
                <ExportButtons start={startDate} end={endDate} onExportPdf={onExportPdf} />
              </Box>
            </Box>
          )
        }
      />

      {loading ? (
        <TransactionsSkeleton />
      ) : (
        <Stack spacing={3}>
          {data?.orgInfos && data.orgInfos.length > 0 ? (
            data.orgInfos.map(org => (
              <Box key={org.id}>
                <PricebookTable
                  data={org.pricebookInfos}
                  headers={pricebookHeaders}
                  leftElement={
                    <Typography variant='p18SemiBold' color='secondary'>
                      {org.orgName}
                    </Typography>
                  }
                  rightElement={{
                    alignWithColumns: true,
                    values: {
                      amountPaid: <AmountPaidSubtotal total={org.subscriptionTotalAmount} />,
                      revShareAmount: <RevShareSubtotal total={org.revShareTotalAmount} />,
                    },
                  }}
                  emptyStateText={emptyStateText}
                />
              </Box>
            ))
          ) : (
            <PricebookTable data={[]} headers={pricebookHeaders} emptyStateText={emptyStateText} />
          )}
        </Stack>
      )}
    </Box>
  );
};

export default TeamTransactionsTable;
